import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Generated, Selectable, Insertable } from 'kysely';
import { z } from '@harvestiq/zod';
export type Json = {
  [K in string]?: boolean | number | string | null;
};

export interface EntityEventsTable {
  id: GeneratedAlways<string>;
  entityId: string;
  entityType: string;
  name: string | null;
  value: null;
  createdAt: Generated<Date>;
  updatedAt: Generated<Date>;
}

export type DbEntityEvent = Selectable<EntityEventsTable>;
export type DbEntityEventInsert = Insertable<EntityEventsTable>;
export type DbEntityEventUpdate = Partial<DbEntityEventInsert>;

export const dbEntityEventSchema = z.object({
  id: z.string().uuid(),
  entityId: z.string(),
  entityType: z.string(),
  name: z.string().nullable(),
  value: z.literal(null),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
expectTypeOf<DbEntityEvent>().toMatchTypeOf<
  z.infer<typeof dbEntityEventSchema>
>();

export const dbEntityEventInsertSchema = dbEntityEventSchema
  .omit({
    id: true,
  })
  .partial()
  .extend({
    entityId: z.string(),
    entityType: z.string(),
  });
type CreateEntityEventFromSchema = z.input<typeof dbEntityEventInsertSchema>;
expectTypeOf<keyof CreateEntityEventFromSchema>().toEqualTypeOf<
  keyof DbEntityEventInsert
>();
expectTypeOf<CreateEntityEventFromSchema>().toMatchTypeOf<DbEntityEventInsert>();

export const dbEntityEventUpdateSchema = dbEntityEventInsertSchema.partial();
type UpdateEntityEventFromSchema = z.input<typeof dbEntityEventUpdateSchema>;
expectTypeOf<keyof UpdateEntityEventFromSchema>().toEqualTypeOf<
  keyof DbEntityEventUpdate
>();
expectTypeOf<UpdateEntityEventFromSchema>().toMatchTypeOf<DbEntityEventUpdate>();
